import { halcyonInstance, hanwahaInstance, gaTelesisInstance, jetStreamInstance } from '../shared_elements';

export const fieldDateFormat = 'DD-MM-YYYY';
export const dayMonthDateFormat = 'DD/MMM/YYYY';
export const backendDateFormat = 'YYYY-MM-DD';
export const displayDateFormat = 'MMMM DD, YYYY';
export const displayDateFormatShort = 'MMM DD, YYYY';
export const displayDateFormatTime = 'MMM DD, YYYY hh:mm A';
export const fieldDateFormatShort = 'DD-MMM-YY';
export const fieldDateTimeFormat = 'DD-MM-YYYY hh:mm A';
export const imgStoragePath = 'https://sparta-aims.ams3.cdn.digitaloceanspaces.com/others/assets/img/';
export const dateMonthYearDateFormat = "DD MMM YYYY"
export const dateMonthYearFormatTime = 'DD MMM, YYYY hh:mm A';
export const timeStampFormatTime = '"YYYY-MM-DD[T]HH:mm:ss"';
export const formatDate = (date, locale = navigator.language) =>
  new Intl.DateTimeFormat(locale, {
    dateStyle: 'medium',
    timeStyle: 'short'
  }).format(new Date(date));

export const assetType = {
  1: 'aircraft',
  2: 'engine',
  3: 'apu',
  4: 'lg',
  5: 'propeller'
}

export const assetTypeName = {
  1: 'Aircraft',
  2: 'Engine',
  3: 'APU',
  4: 'Landing Gear',
  5: 'Propeller'
}

export const assetTypeId = {
  'aircraft': 1,
  'engine': 2,
  'apu': 3,
  'lg': 4,
  'landing_gear': 4,
  'propeller': 5
}

export const assetTypeValues = {
  1: {label:'MSN', urlType:'aircraft'},
  2: {label:'ESN', urlType:'engine'}
};
export const revAssetTypeValues = {
  aircraft:{label:'MSN', assetType:1},
  engine:{label:'ESN', assetType:2},
  apu:{label:'APU', assetType:3},
  lg:{label:'LG', assetType:4},
  propeller:{label:'Propeller', assetType:5},
  fan:{label:'FAN', assetType:6},
  hpc:{label:'HPC', assetType:7},
  hpt:{label:'HPT', assetType:8},
  lpt:{label:'LPT', assetType:9}
};

const isHalcyonOrHanwaha = halcyonInstance || hanwahaInstance;
const hidesEngineSubparts = isHalcyonOrHanwaha || gaTelesisInstance || jetStreamInstance;

export const ASSET_TYPE_OPTIONS = [
	{ label: 'Aircraft', value: 1, hidden: isHalcyonOrHanwaha },
	{ label: 'Engine', value: 2 },
	{ label: 'Propeller', value: 5, hidden: isHalcyonOrHanwaha || gaTelesisInstance },
	{ label: 'Landing Gear', value: 4, hidden: isHalcyonOrHanwaha },
	{ label: 'APU', value: 3, hidden: isHalcyonOrHanwaha },
	{ label: 'Fan', value: 6, hidden: hidesEngineSubparts },
	{ label: 'HPT', value: 8, hidden: hidesEngineSubparts },
	{ label: 'HPC', value: 7, hidden: hidesEngineSubparts },
	{ label: 'LPT', value: 9, hidden: hidesEngineSubparts },
].filter(({ hidden, ...option }) => !hidden);

export const TEXT_OP_LABELS = {
  "=": "Equal To",
  "!=": "Not Equal To",
  contains: "Contains",
  beginsWith: "Starts With",
  endsWith: "Ends With",
  doesNotContain: "Does Not Contain",
  isNull: "Is Empty",
  isNotNull: "Is Not Empty"
};
export const SELECT_OP_LABELS = {
  "=": "Equal To",
  "!=": "Not Equal To",
};